import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { ScoringResponse } from '../interfaces/scoring';
import { ISearchTransactionResponse } from '../interfaces/searchTransactionResponse';
import { ISignPdfBody } from '../interfaces/signPdf';
import { UrlFactory } from '../utils/url-factory';
import { environment } from '../../environments/environment';
import { StoreService } from './store.service';

@Injectable({
  providedIn: 'root',
})
export class ObdService {
  httpClient = inject(HttpClient);

  clientDni$: BehaviorSubject<string | null> = new BehaviorSubject<
    string | null
  >(null);

  clientPhoneNumber$: BehaviorSubject<string | null> = new BehaviorSubject<
    string | null
  >(null);

  constructor(
    private _http: HttpClient,
    private _storeService: StoreService,
  ) {}

  getObdLink(idOperacion: number = 1): Observable<any> {
    const url = UrlFactory.postNewLinkOperation();
    const body = {
      dni: this.clientDni$.value ? this.clientDni$.value : 40068725,
      id_op_client: idOperacion,
      telefono: this.clientPhoneNumber$.value
        ? this.clientPhoneNumber$.value
        : '',
      firma: false,
    };
    return this.httpClient.post<any>(url, body);
  }

  signPdf(body: ISignPdfBody): Observable<any> {
    const url = UrlFactory.postSignContract();
    return this.httpClient.post<any>(url, body);
  }

  validateUrlId(urlId: string): Observable<ISearchTransactionResponse> {
    const url = UrlFactory.postSearchTransaction();
    const body: { uuid: string } = {
      uuid: urlId,
    };
    return this._http.post<ISearchTransactionResponse>(url, body).pipe(
      tap((resp) => {
        if (resp?.empConfig) {
          const logoUrl =
            resp.empConfig.logo
              ? `${environment.API_URL}/imgs/logos/${resp.empConfig.logo}`
              : '../../../assets/obd-logo.svg';
          this._storeService.logoImageUrl$.next(logoUrl);
        }
      }),
    );
  }

  getScoring(
    documentNumber: number,
    uuid: string,
    gender?: string,
  ): Observable<ScoringResponse> {
    const body = {
      nrodoc: documentNumber,
      uuid: uuid,
    };

    const url = UrlFactory.getCreditScore();

    return this._http.post<ScoringResponse>(url, body);
  }

  closeOperation(): Observable<any> {
    const url = UrlFactory.closeOperation();
    const uuid = this._storeService.transactionId$.value || '';
    return this._http.post<any>(url, { uuid });
  }
}
